import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { Delete, Get, PostBlob, Post } from '@/api/api-middleware';
import { getCompanyID, getEmployeeID } from '@/helpers/Utils';
import { apiPath } from '@/constants/defaultValues';
const initialState = {
  loading: false,
  MainMenu : [],
  error: '',
};

export const GetMainMenuByCompanyID = createAsyncThunk('menu/GetMainMenuByCompanyID',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}${'api/Lookup/System/GetAllMenu'}/${getCompanyID()}`,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    clearCurrentItem: (state) => { 
      state.MainMenu = [];
     },
  },
  extraReducers: (builder) => {

    builder.addCase(GetMainMenuByCompanyID.pending, (state) => {
      state.loading = true;
    })
    .addCase(GetMainMenuByCompanyID.fulfilled, (state, action) => {
      state.loading = false;
      state.MainMenu = action.payload;
      state.error = '';
    })
    .addCase(GetMainMenuByCompanyID.rejected, (state, action) => {
      state.loading = false;
      state.MainMenu = [];
      state.error = action.payload ?? 'An error occurred';
    });
  },
});

export const { clearCurrentItem } = menuSlice.actions;
export default menuSlice.reducer;
